export const StatesMassivePayments = {
  CREATED: "CREATED",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  PARTIAL: "PARTIAL",
};

export const getTagType = (state) => {
  switch (state) {
    case StatesMassivePayments.CREATED:
      return "info";
    case StatesMassivePayments.PROCESSING:
      return "warning";
    case StatesMassivePayments.COMPLETED:
      return "success";
    case StatesMassivePayments.FAILED:
      return "error";
    case StatesMassivePayments.PARTIAL:
      return "normal";
  }
};

export const getFee = (amount, comission) => {
  if (isNaN(amount)) return 0;
  if (isNaN(comission)) return 0;

  return ((amount * comission) / 100)?.toFixed(2);
};
